import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {configStore, userStore} from 'app/store/global';
import {Store} from 'app/store';
import CollectionInterface from 'app/interfaces/CollectionInterface';
import SelectPicker from 'app/components/reusable/SelectPicker';
import {UNKNOWN_COUNTRY} from 'app/utils/Consts';
import {observer} from 'mobx-react';

interface RowCountryCodeProps {
    rowClass: string;
    errorHint: ReactNode;
    cleanError: (field: string) => void;
    country_code: string;
    countryToRemove?: string[];
}

const resolveCountryCode = (countryCode?: string): string => {
    const candidate = countryCode && countryCode !== UNKNOWN_COUNTRY
        ? countryCode
        : userStore.signUpCountry;

    if (!candidate || candidate === UNKNOWN_COUNTRY) {
        return '';
    }

    const isAvailable = configStore.REG_FLAGS.some(flag => flag.code === candidate);

    return isAvailable ? candidate : '';
};

export const RowCountryCode = observer(
    class RowCountryCode extends Component<RowCountryCodeProps> {
    state = {
        countryCode: resolveCountryCode(this.props.country_code)
    };

    availableFlags = (): CollectionInterface[] => configStore.REG_FLAGS.map((flag): CollectionInterface => ({
        image: flag.image,
        text: flag.name,
        value: flag.code
    })).filter(flag => !this.props.countryToRemove?.includes(`${flag.value}`));

    handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedValue = e.target.value;

        this.setState({countryCode: selectedValue});
        this.cleanError();
    };

    cleanError = (): void => {
        this.props.cleanError('country_code');
    };

    render(): ReactNode {
        const {rowClass, errorHint} = this.props;
        const {countryCode} = this.state;

        return <div className={rowClass}>
            <label className="field-label" htmlFor="field-country">{I18n.t('select_country')}</label>
            <div className="field"
                onClick={this.cleanError}>
                {userStore.unknownCountryCode() || !userStore.fullRegistered()
                    ? <div className="classical-select select-with-images">
                        <SelectPicker
                            onChange={this.handleOnChange}
                            name="country_code"
                            value={countryCode}
                            collection={this.availableFlags()}
                            className="select-country"
                            placeholder={I18n.t('select_a_country')}
                            id="field-country"
                        />
                        <div className="field__select-arrow"/>
                    </div>
                    : <input className="field__input"
                        name="country_code"
                        defaultValue={Store.userCountry(countryCode)} disabled/>}
            </div>
            {errorHint}
        </div>;
    }
    }
);
